
export class SetRdbmsStatusLastUpdated {
    static readonly type = '[RDBMS] Set Last Updated Timestamp';
    constructor(public timestamp: number) {}
}

export class ShowTrialWidgetType {
    static readonly type = '[RDBMS] Show Trial Widget Type';
}
